<template>
  <div class="card-item">
    <div>
      <table cellpadding="0" cellspacing="0" id="1">
        <tr>
          <td>
            <div id="cal">
              <div id="top">{{ title }}</div>

              <ul id="wk" class="lab">
                <li><b>S</b></li>
                <li>M</li>
                <li>T</li>
                <li>W</li>
                <li>T</li>
                <li>F</li>
                <li><b>S</b></li>
              </ul>

              <ul id="wk" v-for="item in arr" :key="item.id">
                <li class="blue" :style="{ background: item[0].color ? item[0].color + ' !important' : '' }">
                  <el-tooltip placement="top" class="item" effect="dark" :content="item[0].name" v-if="item[0].name">
                    <span :style="{ color: item[0].color ? '#fff !important' : '' }">{{ item[0].day }}</span
                    >&nbsp;
                  </el-tooltip>
                  <span v-else :style="{ color: item[0].color ? '#fff !important' : '' }">{{ item[0].day }}</span
                  >&nbsp;
                </li>

                <li v-for="index in 5" :key="index" :style="{ background: item[index].color ? item[index].color + ' !important' : '' }">
                  <el-tooltip placement="top" class="item" effect="dark" :content="item[index].name" v-if="item[index].name">
                    <span :style="{ color: item[index].color ? '#fff !important' : '' }">{{ item[index].day }}</span
                    >&nbsp;
                  </el-tooltip>
                  <span v-else :style="{ color: item[index].color ? '#fff !important' : '' }">{{ item[index].day }}</span
                  >&nbsp;
                </li>

                <li class="blue" :style="{ background: item[6].color ? item[6].color + ' !important' : '' }">
                  <el-tooltip placement="top" class="item" effect="dark" :content="item[6].name" v-if="item[6].name">
                    <span :style="{ color: item[6].color ? '#fff !important' : '' }">{{ item[6].day }}</span
                    >&nbsp;
                  </el-tooltip>
                  <span v-else :style="{ color: item[6].color ? '#fff !important' : '' }">{{ item[6].day }}</span
                  >&nbsp;
                </li>
              </ul>
              <div id="bm"></div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      currentMonthDays: '',
      currentWeekday: '',
      lastMonthDays: '',
      arr: []
    }
  },
  props: ['title', 'date', 'list'],
  watch: {
    list: {
      handler(newValue) {
        this.getData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getData() {
      this.currentWeekday = moment(this.date)
        .date(1)
        .weekday() // 获取当月1日为星期几

      this.lastMonthDays = moment(this.date)
        .subtract(1, 'month')
        .daysInMonth() // 获取上月天数

      this.currentMonthDays = moment(this.date).daysInMonth() // 获取当月天数

      let holidays = []

      for (let i of this.list) {
        if (i.type == 'Statutory Holiday' || i.type == 'Custom Holiday') {
          if (moment(this.date).month() == moment(i.date).month()) {
            holidays.push(i)
          }
        }
      }
      // 总天数是31，1号是周五或者周六6个[]
      // 总天数是30，1号是周六6个[]
      var daysArr
      if ((this.currentMonthDays == '31' && this.currentWeekday == '5') || this.currentWeekday == '6' || (this.currentMonthDays == '30' && this.currentWeekday == '6')) {
        daysArr = [[], [], [], [], [], []]
      } else {
        daysArr = [[], [], [], [], []]
      }
      // const getDay = day => (day <= this.lastMonthDays ? day : (day <= (this.lastMonthDays + this.currentMonthDays)) ? day - this.lastMonthDays : day - (this.lastMonthDays + this.currentMonthDays)); // 日期处理
      const getDay = day => (day <= this.lastMonthDays ? '' : day <= this.lastMonthDays + this.currentMonthDays ? day - this.lastMonthDays : '') // 日期处理
      for (let i = 0; i < 7; i += 1) {
        let virtualDay = this.lastMonthDays - this.currentWeekday + i + 1
        for (let j = 0; j < daysArr.length; j += 1) {
          if (getDay(virtualDay + j * 7)) {
          }

          daysArr[j][i] = { day: getDay(virtualDay + j * 7) }
          for (let d of holidays) {
            if (moment(d.date).date() == getDay(virtualDay + j * 7)) {
              let color
              if (d.type == 'Statutory Holiday') {
                color = '#8BB1F2'
              }
              if (d.type == 'Custom Holiday') {
                color = '#44C9C1'
              }
              if (daysArr[j][i].color != '#44C9C1') {
                daysArr[j][i] = { day: getDay(virtualDay + j * 7), color: color, name: d.name }
              }
            }
          }
        }
      }
      this.arr = daysArr
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.card-item {
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  display: inline-block;
}
.cal {
  position: relative;

  margin: 20px;
}

.choose {
  // width: 30px;
  // height: 30px;
  // line-height: 30px;
  // text-align: center;
  // display: inline-block;
  // background: #429e6c;
  // color: #fff;
  // border-radius: 50%;
}

#cal #top {
  width: 163px;
  height: 26px;
  line-height: 26px;
  background: #576aa4;
  text-align: center;
  color: #fff;
  clear: both;
  font-size: 14px;
  font-weight: 600;
}
#cal ul#wk {
  margin: 0;
  padding: 0;
  height: 26px;
  color: #888;
  font-size: 14px;
  // border-left: 1px solid #429e6c;
  // border-right: 1px solid #429e6c;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#cal ul#wk li {
  text-align: center;
  width: 23px;
  height: 26px;
  line-height: 26px;
  border-right: 1px solid #dfe4ee;
  border-top: 1px solid #dfe4ee;
  background: #f8f9fd;
  margin: auto;
}
#wk {
  border-left: 1px solid #dfe4ee;
}
#cal ul#wk li span {
  font-size: 12px;
  font-weight: 400;
  color: #8b8e9a;
  margin-left: 3px;
}
#cal ul#wk li b {
  font-weight: normal;
  // color: #429e6c;
}
#cal #bm {
  text-align: right;

  border-bottom: 1px solid #dfe4ee;
  border-left: 1px solid #dfe4ee;
  border-right: 1px solid #dfe4ee;
  clear: both;
  font-size: 14px;
}
.blue {
  background: #ebf0ff !important;
}
.lab {
  background: #ebf0ff !important;
  border-right: 1px solid #dfe4ee;
  li {
    width: 25px;
    height: 26px;
    border: none !important;
    background: #ebf0ff !important;
    border-left: 1px solid #dfe4ee;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/WorkFlow/card.vue